<template>
  <div class="MainView">
    <Sidebar v-if="!$route.meta.hideSidebar"/>
    <Views/>
  </div>
</template>
<script>
import Sidebar from "./Sidebar";
import Views from "./Views";
import { service } from "@/helper/Rest";
export default {
  name: "MainView",
  components: {
    Sidebar,
    Views
  }
};
</script>
<style lang="scss" scoped>
.MainView {
  position: relative;
  height: 100%;
  display: flex;
  width: 100%;
  // width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/MainView.vue